import { Divider, Grid, List, ListItem } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxIcons from "@rf-l1/MxIcons";
import {
  IconAlertTriangleFilled,
  IconCheck,
  IconCircleXFilled,
  IconInfoCircleFilled
} from "@tabler/icons-react";

interface MxTooltipItemInfoProps {
  type: "SUCCESS" | "INFO" | "ERROR";
  label: string;
  value: string | { message: string }[];
  showDivider?: boolean;
}
const MxTooltipItemInfo = (props: MxTooltipItemInfoProps) => {
  return (
    <Grid container my={0.5} alignItems={"center"}>
      <Grid container flex={1} gap={1} alignItems="center">
        <Grid item xs="auto">
          {props.type == "INFO" && (
            <MxIcons
              size={16}
              color="info.main"
              children={<IconInfoCircleFilled />}
            />
          )}
          {props.type == "SUCCESS" && (
            <MxIcons size={16} color="success.main" children={<IconCheck />} />
          )}
          {props.type == "ERROR" && (
            <MxIcons
              size={16}
              color="warning.main"
              children={<IconAlertTriangleFilled />}
            />
          )}
        </Grid>
        <Grid item flex={1}>
          <MxTypography
            variant="overline"
            color="warning.main"
            fontWeight={600}
            component={"span"}
          >
            {props.label}
          </MxTypography>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <CastMsg value={props.value} />
      </Grid>

      {props.showDivider && (
        <Grid container item xs={12} mb={1}>
          <Divider sx={{ flex: 1 }} />
        </Grid>
      )}
    </Grid>
  );
};

export default MxTooltipItemInfo;

const CastMsg = (props: { value: string | { message: string }[] }) => {
  if (typeof props.value === "string") {
    return (
      <MxTypography
        my={0.5}
        ml={3}
        variant="overline"
        fontWeight={400}
        component={"span"}
        color="grey.600"
      >
        {props.value}
      </MxTypography>
    );
  }

  if (Array.isArray(props.value)) {
    if (props.value[0] && typeof props.value[0] === "string") {
      return (
        <ListItem key={"e"}>
          <MxTypography
            color="grey.600"
            variant="body2"
            fontWeight={400}
            component={"span"}
            ml={1}
          >
            {props.value[0]}
          </MxTypography>
        </ListItem>
      );
    }
    return (
      <List disablePadding>
        {props.value.map((e, i) => (
          <ListItem key={i}>
            <MxTypography
              color="grey.600"
              variant="body2"
              fontWeight={400}
              component={"span"}
              ml={1}
            >
              {e.message}
            </MxTypography>
          </ListItem>
        ))}
      </List>
    );
  }
  return null;
};
